/**
 * G10. Граница: вопросы офицера (2–3), по 3 ответа; знания и деньги
 * подсвечивают верный пометкой. Все точные — шанс +10 %, все мимо — −10 %.
 */
import { t } from '@life/i18n';
import type { BorderInput, BorderState } from '@life/minigames';
import { useState } from 'preact/hooks';
import type { MinigameScreenProps } from './types';
import { Choice } from './ui/Choice';

export function Border({ state, onInput }: MinigameScreenProps<BorderInput, BorderState>) {
  const [picks, setPicks] = useState<(number | null)[]>(() => state.questions.map(() => null));
  const complete = picks.every((p) => p !== null);

  return (
    <>
      <p class="hint">{t('ui.minigame.border.rules', { p: Math.round(state.delta * 100) })}</p>
      {state.questions.map((q, i) => (
        <div class="q" key={q.id} data-question={i}>
          <p class="q-text">{t(q.key)}</p>
          <Choice
            label={t(q.key)}
            items={q.answers.map((key, j) => ({ text: t(key), ...(q.hint === j ? { note: t('ui.minigame.hint') } : {}) }))}
            value={picks[i] ?? null}
            onChange={(j) => setPicks(picks.map((p, k) => (k === i ? j : p)))}
          />
        </div>
      ))}
      <div class="picks">
        <button type="button" class="btn accent" disabled={!complete} onClick={() => onInput({ picks: picks.map((p) => p ?? -1) })}>
          {t('ui.minigame.border.answer')}
        </button>
        <button type="button" class="btn" onClick={() => onInput({ picks: [], stay: true })}>
          {t('ui.minigame.border.stay')}
        </button>
      </div>
    </>
  );
}
